import {BFormGroup, BFormInput, BFormTextarea, BModal} from "bootstrap-vue";

export default {
  components: {
    BModal, BFormGroup, BFormInput, BFormTextarea
  },
  props: {
    value: Object,
    type: {
      default: 'increment',
      type: String
    }
  },
  data() {
    return {
      disabled: false,
      scores: this.value,
      description: ''
    };
  },
  watch: {
    scores(newVal) {
      this.$emit("input", newVal);
    },
    value(newVal) {
      this.scores = newVal;
      this.description = ''
    },
  },
  methods: {
    async addScores() {
      this.disabled = true;
      try {
        const response = await this.$axios.post(`admin/physical-scores/update`, {
          customer_id: this.scores.customer_id,
          score: this.scores.scores,
          type: this.type,
          description: this.description
        });

        this.$root.notify(response.data.message, "success");
        this.$root.$emit('bv::hide::modal', 'customer-scores')
        this.$emit("set-new-scores", {scores: this.scores.scores, description: this.description});

        this.description = ''
      } catch (error) {
        this.$root.notify(error);
      }
      this.disabled = false;
    },
  },
}
